import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ProductDetail.css';

const ProductDetail = () => {
  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Product database
  const products = {
    'carhartt-j97-detroit-2005': {
      name: 'Carhartt J97 Detroit',
      year: '2005',
      price: '$8000',
      category: 'outerwear',
      cloth: 'cotton duck canvas',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/mos.jpg',
      description: '2005 Carhartt J97 Detroit jacket in moss green. Classic workwear silhouette with blanket lining. Heavy-duty construction with corduroy collar. Vintage piece in excellent condition.'
    },
    'carhartt-j160-active-2006': {
      name: 'Carhartt J160 Active Jacket',
      year: '2006',
      price: '$3500',
      category: 'outerwear',
      cloth: 'nylon quilted',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/gris.jpg',
      description: '2006 Carhartt J160 active jacket in grey. Quilted nylon construction with warm insulation. Practical workwear design with multiple pockets. Perfect for cold weather.'
    },
    'carhartt-santa-fe-aztec-1993': {
      name: 'Carhartt Santa Fe Aztec',
      year: '1993',
      price: '$5000',
      category: 'outerwear',
      cloth: 'cotton blend',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/morada.jpg',
      description: '1993 Carhartt Santa Fe Aztec jacket in purple. Classic boxy fit with corduroy collar. Rare vintage piece featuring distinctive southwestern pattern. Single size available.'
    },
    'carhartt-brk-santa-fe-1999': {
      name: 'Carhartt BRK Santa Fe',
      year: '1999',
      price: '$6000',
      category: 'outerwear',
      cloth: 'cotton canvas',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/roja.jpg',
      description: '1999 Carhartt BRK Santa Fe jacket in burgundy red. Traditional workwear construction with blanket lining. Features corduroy collar and reinforced stitching. Vintage condition.'
    },
    'carhartt-chore-jacket-2010s': {
      name: 'Carhartt Chore Jacket',
      year: '2010s',
      price: '$1000',
      category: 'outerwear',
      cloth: 'denim',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/chore.jpg',
      description: '2010s Carhartt chore jacket in indigo denim. Classic workwear styling with multiple pockets. Durable construction with blanket lining. Timeless design for everyday wear.'
    },
    'santa-fe-j102-mos-2000': {
      name: 'Santa Fe J102 Mos',
      year: '2000',
      price: '$4500',
      category: 'outerwear',
      cloth: 'cotton canvas',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/green.jpg',
      description: '2000 Santa Fe J102 jacket in forest green. Heavy-duty canvas construction with quilted lining. Features corduroy collar and snap closure. Vintage workwear at its finest.'
    },
    'carhartt-j130-active-2010': {
      name: 'Carhartt J130 Active Jacket',
      year: '2010',
      price: '$3000',
      category: 'outerwear',
      cloth: 'cotton duck',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/brown.jpg',
      description: '2010 Carhartt J130 active jacket in brown. Classic duck canvas with thermal lining. Multiple pockets and durable hardware. Practical design for work and outdoor activities.'
    },
    'choppers-jacket-2000s': {
      name: 'Choppers Jacket',
      year: '2000s',
      price: '$3500',
      category: 'outerwear',
      cloth: 'leather',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/choppers.jpg',
      description: '2000s Choppers leather jacket. Vintage motorcycle style with distressed finish. Heavy-duty leather construction with multiple zippers. Authentic vintage biker aesthetic.'
    },
    'carhartt-aztec-jacket-1992': {
      name: 'Carhartt Aztec Jacket',
      year: '1992',
      price: '$5500',
      category: 'outerwear',
      cloth: 'wool blend',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/aztec.jpg',
      description: '1992 Carhartt Aztec jacket with southwestern pattern. Rare vintage piece featuring geometric design. Wool blend construction with blanket lining. Highly collectible workwear item.'
    }
  };

  const product = products[slug];

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__container">
          <Link to="/shop/vintage" className="product-detail__back">
            ← Back to Selection
          </Link>
          <p>Product not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <Link to="/shop/vintage" className="product-detail__back">
          ← back to selection
        </Link>

        <div className="product-detail__content">
          <div className="product-detail__image">
            <img src={product.image} alt={product.name} />
          </div>

          <div className="product-detail__info">
            <div className="product-detail__main">
              <div className="product-detail__field">
                <span className="product-detail__label">style</span>
                <span className="product-detail__value">{product.name}</span>
              </div>

              <div className="product-detail__field">
                <span className="product-detail__label">year</span>
                <span className="product-detail__value">{product.year}</span>
              </div>

              <div className="product-detail__field">
                <span className="product-detail__label">cloth</span>
                <span className="product-detail__value">{product.cloth}</span>
              </div>

              <div className="product-detail__field">
                <span className="product-detail__label">category</span>
                <span className="product-detail__value">{product.category}</span>
              </div>

              <div className="product-detail__field">
                <span className="product-detail__label">price</span>
                <span className="product-detail__value">{product.price}</span>
              </div>

              <button className="product-detail__button" disabled>
                Currently Unavailable
              </button>
            </div>

            <div className="product-detail__description">
              <h3 className="product-detail__description-title">details</h3>
              <p className="product-detail__description-text">{product.description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
